import React, { useMemo } from "react";
import { FaIcon } from "../../common/Icons.jsx";

const PhaseCollapser = ({ isCollapsed = true, handleClick }) => {
  const label = useMemo(
    () =>
      isCollapsed
        ? I18n.t("show_advanced_options").toUpperCase()
        : I18n.t("hide_advanced_options").toUpperCase(),
    [isCollapsed]
  );

  return (
    <div className="phase-collapser" onClick={handleClick}>
      <FaIcon type={`${isCollapsed ? "plus" : "minus"}`} className='fa-lg' />
      <a role="button">
        {label}
      </a>
    </div>
  );
};

export default PhaseCollapser;
